import type { MantineColor } from '@mantine/core';
import { type NotificationData, notifications } from '@mantine/notifications';
import { isAxiosError } from 'axios';
import type { ReactNode } from 'react';
import { IconX } from '@tabler/icons-react';

type Variant = 'info' | 'warning' | 'error' | 'success' | 'system';

export interface ShowNotificationProps extends Omit<
  NotificationData,
  'message' | 'variant'
> {
  message?: ReactNode;
  variant: Variant;
  error?: unknown;
}

const indicatorColor: Record<Variant, MantineColor> = {
  info: 'secondary.7',
  warning: 'yellow.7',
  error: 'red.7',
  success: 'green.7',
  system: 'blue.0',
};

const NETWORK_NOTIFICATION_ID = 'network-error';

export const showNotification = ({
  message = '',
  variant = 'success',
  error,
  ...props
}: ShowNotificationProps) => {
  // ERR_NETWORK показывается глобально через showNetworkErrorNotification —
  // локальные onError в формах пропускаем, чтобы не было двойного тоста.
  if (isAxiosError(error) && error.code === 'ERR_NETWORK') {
    return;
  }

  notifications.show({
    variant,
    message,
    color: indicatorColor[variant],
    closeButtonProps: {
      icon: <IconX size={22} color='var(--mantine-color-primary-4)' />,
    },
    ...props,
  });
};

export const showNetworkErrorNotification = () => {
  notifications.show({
    id: NETWORK_NOTIFICATION_ID,
    variant: 'error',
    message:
      'Потеряно соединение с интернетом. Проверьте подключение и попробуйте снова.',
    color: indicatorColor.error,
    closeButtonProps: {
      icon: <IconX size={22} color='var(--mantine-color-primary-4)' />,
    },
  });
};
